<template>
    <div>
        <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
            :showButtons="panel.showButtons">
            <div slot="content-main">
                <div>
                    <br />
                    <NotificationConfig />
                </div>
            </div>
        </Panel>
    </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import NotificationConfig from '../../../components/modules/adm/notification/NotificationConfig.vue'

import { mapMutations } from "vuex";


export default {
    name: "NotificationView",
    components: { Panel, NotificationConfig },
    data() {
        return {
            panel: {
                module: "Adm",
                title: "Notificação",
                showFilter: false,
                showSearch: false,
                showButtons: false,
            },
        };
    },
    mounted() {
        this.removeLoading(["panel"]);
    },
    methods: {
        ...mapMutations("generic", ["removeLoading"]),
    }
};
</script>